import { useState } from "react";
import { useTranslations } from "contexts/LocalizationContext/hooks";
import { FormSuccessMessage } from "components/FormControl";
import { ChakraFlex as Flex, ChakraHeading as Heading, ChakraBox as Box } from "@airhelp/react-ui-components";
import SubscribeForm from "./SubscribeForm";
import type { SubscribeProps } from "./Subscribe.d";

const Subscribe = ({ heading, text, buttonText, listId = "blog", fullWidth, mobileView }: SubscribeProps) => {
  const [hasSubscribed, setHasSubscribed] = useState(false);
  const translations = useTranslations();
  const width = fullWidth ? "full" : "60%";

  return (
    <Flex flexDir="column" align="flex-start" color="white" py={6}>
      <Heading color="inherit" variant="h2" as="h2" pb={2} w={{ base: "full", lg: width }} textAlign="left">
        {heading}
      </Heading>
      <Box w={{ base: "full", lg: width }} textAlign="left">
        {text}
      </Box>
      {!hasSubscribed ? (
        <SubscribeForm
          setHasSubscribed={setHasSubscribed}
          buttonText={buttonText}
          listId={listId}
          fullWidth={fullWidth}
          mobileView={mobileView}
        />
      ) : (
        <FormSuccessMessage text={translations("subscribe_form_submit_succesful")} />
      )}
    </Flex>
  );
};

export default Subscribe;
